(() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  const saleSummarySelector = '.header__inline-menu summary#HeaderMenu-sale';

  const initializeMobile = () => {
    const template = document.querySelector('#CustomMobileSaleMenuV1');
    const summary = document.querySelector('#HeaderDrawer-sale');
    const details = summary?.closest('details');
    const menu = details?.querySelector(':scope > .menu-drawer__submenu .menu-drawer__inner-submenu > ul');
    if (!template || !details || !menu || details.dataset.customMobileSaleMenu === 'true') return;

    menu.replaceChildren(template.content.cloneNode(true));
    menu.classList.add('custom-mobile-sale-menu-v1');
    details.dataset.customMobileSaleMenu = 'true';
  };

  const positionPanel = (details) => {
    if (!desktop.matches) return;
    const detailsBox = details.getBoundingClientRect();
    const panelWidth = Math.min(window.innerWidth - 40, 714);
    const viewportLeft = Math.max(20, detailsBox.right - panelWidth);
    details.style.setProperty('--custom-sale-panel-left', `${viewportLeft - detailsBox.left}px`);
  };

  const initialize = () => {
    initializeMobile();
    if (!desktop.matches) return;
    const template = document.querySelector('#CustomDesktopSaleMegaMenuV1');
    const summary = document.querySelector(saleSummarySelector);
    const details = summary?.closest('details');
    const menu = details?.querySelector(':scope > .header__submenu');
    if (!template || !details || !menu || details.dataset.customSaleMegaMenu === 'true') return;

    menu.replaceChildren(template.content.cloneNode(true));
    menu.classList.add('custom-sale-mega-menu-v1');
    details.dataset.customSaleMegaMenu = 'true';
    positionPanel(details);

    window.addEventListener('resize', () => positionPanel(details), { passive: true });
    details.addEventListener('toggle', () => {
      if (details.open) positionPanel(details);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  desktop.addEventListener('change', (event) => {
    if (event.matches) initialize();
  });
})();
